export const DDialogAlign = wcardinal.ui.DDialogAlign;